import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const panelService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
};

const MODULE = {
    PANEL: 'panels',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll(filter) {
    const request = {
        params: {
            location: filter?.location,
            panel_type: filter?.panelType,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PANEL}`, request);
}

export function store (data) {
    const request = {
        location_uuid: data.locationUUID,
        panel_type_uuid: data.panelTypeUUID,
        name: data.name,
        phone_code: data.phoneCode,
        phone: data.phone,
        email: data.email,
        address: data.address,
        map_link: data.mapLink,
    };

    return apiHelper(API_URL).post(`/${MODULE.PANEL}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PANEL}/${uuid}`);
}

export function update (data) {
    const request = {
        location_uuid: data.locationUUID,
        panel_type_uuid: data.panelTypeUUID,
        name: data.name,
        phone_code: data.phoneCode,
        phone: data.phone,
        email: data.email,
        address: data.address,
        map_link: data.mapLink,
    };

    return apiHelper(API_URL).put(`/${MODULE.PANEL}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PANEL}/status/${data.uuid}`, request);
}